export default __webpack_public_path__ + "static/media/CheckedBoxIcon.69ba0c4a.svg";